<template>
  <div class="link">
    <div class="link-tab">
      <span @click="selectTab(1)" :class="showTabs == 1 ? 'link-tab-active' : ''">已确认</span>
      <span @click="selectTab(2)" :class="showTabs == 2 ? 'link-tab-active' : ''">未审核</span>
    </div> 
    <div class="link-main" v-if="showTabs == 1">
      <Row :gutter="30">
        <Col :md="12" :xl="8" :xxl="6" class="w-20">
          <div class="addPro pro" @click="addMan">
            <i class="icon iconfont icon-jia3"></i>
            <span>添加联系人</span>
          </div>
        </Col>
        <Col
          :md="12"
          :xl="8"
          :xxl="6"
          v-for="(item, index) in linkList"
          :key="'releaseInt-' + index"
          class="w-20"
          v-if="linkList.length"
        >
          <div class="pro">
            <div class="pro-top">
              <div class="title">
                <div>
                  <span class="name">{{item.name}}</span>
                  <span class="job">{{item.jobTitle}}</span>
              </div>
                <span class="job2">{{item.linkType}}</span>
              </div>
              <p>手机：{{item.mob}}</p>
              <p>邮箱：{{item.email}}</p>
              <p>电话：{{item.tel}}</p>
            </div>
            <div class="pro-tool" v-if="item.changeState !== 1">
              <div class="pro-tool-item" @click="editModal(item)" style="color:#1890ff">编辑</div>
              <div class="pro-tool-line"></div>
              <div class="pro-tool-item z-del">
                <Poptip confirm title="您确认删除这条内容吗？" @on-ok="delItemByStatus(item)" style="color:#ff0000">删除</Poptip>
              </div>
            </div>
            <div class="pro-tool" v-else>
              <div class="pro-tool-item" @click="$Message.warning('等待主办审核');" style="color:#1890ff">编辑</div>
              <div class="pro-tool-line"></div>
              <div class="pro-tool-item" @click="$Message.warning('等待主办审核');" style="color:#ff0000">删除</div>
            </div>
          </div>
        </Col>
      </Row>
      <!-- <div class="my-page" v-if="totalCount > pageSize">
            <Page
                show-total
                show-elevator
                :page-size="pageSize"
                :current="pageIndex"
                :total="totalCount"
                @on-change="changePage"
                @on-page-size-change="changePageSize"
            />
      </div>-->
    </div>
    <div class="link-main" v-if="showTabs == 2">
      <Row :gutter="30">
        <Col :md="12" :xl="8" :xxl="6" class="w-20">
          <div class="addPro pro" @click="addMan">
            <i class="icon iconfont icon-jia3"></i>
            <span>添加联系人</span>
          </div>
        </Col>
        <Col
          :md="12"
          :xl="8"
          :xxl="6"
          v-for="(item, index) in linkList"
          :key="'releaseInt-' + index"
          class="w-20"
          v-if="linkList.length"
        >
          <div class="pro">
            <div class="pro-top">
              <div class="title">
                <div>
                  <span class="name">{{item.name}}</span>
                  <span class="job">{{item.jobTitle}}</span>
                </div>
                <span class="job2">{{item.linkType}}</span>
              </div>
              <p>手机：{{item.mob}}</p>
              <p>邮箱：{{item.email}}</p>
              <p>电话：{{item.tel}}</p>
              <div class="state-Type">
                <span v-if="item.commandId == 1" style="color:#1890ff;">状态：新增</span>
                <span v-if="item.commandId == 2" style="color:#fe781d;">状态：修改</span>
                <span v-if="item.commandId == 3" style="color:#009944;">状态：删除</span>
              </div>
            </div>
            <div class="pro-tool">
              <div class="pro-tool-item" v-if="item.commandId !== 3" @click="editModal2(item)" style="color:#1890ff">编辑</div>
              <div class="pro-tool-line"></div>
              <div class="pro-tool-item z-del">
                <Poptip confirm title="您确认删除这条内容吗？" @on-ok="delItem(item)" style="color:#ff0000">删除</Poptip>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <!-- <div class="my-page" v-if="totalCount > pageSize">
            <Page
                show-total
                show-elevator
                :page-size="pageSize"
                :current="pageIndex"
                :total="totalCount"
                @on-change="changePage"
                @on-page-size-change="changePageSize"
            />
      </div>-->
    </div>
    <addManModel
      :show="modelShow"
      :modelTitle="modelTitle"
      :options="options"
      :linkType="linkType"
      @close="modelShow = false"
      @addFinsh="addFinsh"
      @linkTo="linkTo"
    ></addManModel>
  </div>
</template>
<script>
import qs from "qs";
import addManModel from "./add-operate";
import { mapGetters } from "vuex";
export default {
  name: "company-info-linkman",
  data() {
    return {
      showTabs: 1,
      modelTitle: "", // 弹框标题
      modelShow: false,
      options: {},
      linkList: [],
      linkType: []
    };
  },
  components: { addManModel },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition"
    }),
    header() {
      return this.$store.state.header;
    }
  },
  created() {
    this.init();
  },
  methods: {
    selectTab(type) {
      this.showTabs = type;
      this.linkList = [];
      switch (type) {
        case 1:
          this.getYesLink();
          break;
        case 2:
          this.getNoLink();
      }
    },
    addMan() {
      this.modelShow = true;
      this.modelTitle = "添加联系人";
      this.options = {
        msg: null,
        model: null
      };
    },
    editModal(item) {
      this.modelShow = true;
      this.modelTitle = "编辑联系人";
      this.options = {
        msg: item,
        model: "edit",
        status: 1
      };
      console.log(this.options,222)
    },
    editModal2(item) {
      this.modelShow = true;
      this.modelTitle = "编辑联系人";
      this.options = {
        msg: item,
        model: "edit"
      };
      console.log(this.options,333)
    },
    delItem(item) { 
      // 删除
      console.log(item);
      this.$http
        .delete(`/api/contactDown?recordId=${item.recordId}`, this.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.$Message.success("删除成功！");
            switch (this.showTabs) {
              case 1:
                this.getYesLink();
                break;
              case 2:
                this.getNoLink();
            }
          } else {
            this.$Message.error("删除失败，请重新尝试");
          }
        });
    },
    async delItemByStatus(item) {
      const req = {
        data: {
          id: item.id,
          jonId: this.joinInfo.joinId,
          exhibitionId: this.exhibition.id
        }
      };
      this.$http.delete(`/api/Contact`, { data: req.data, ...this.header }).then(res => {
        if (res.status === 200 && res.data.successed) {
          this.$Message.success("删除成功！");
          switch (this.showTabs) {
            case 1:
              this.getYesLink();
              break;
            case 2:
              this.getNoLink();
          }
        } else {
          this.$Message.error("删除失败，请重新尝试");
        }
      });
    },
    init() {
      this.getYesLink();
      this.getLinkType();
    },
    // 添加 / 修改 完成
    addFinsh() {
      this.linkList = [];
      this.showTabs = 1;
      switch (this.showTabs) {
        case 1:
          this.getYesLink();
          break;
        case 2:
          this.getNoLink();
      }
    },
    getYesLink() {
      // 获取已确认的的联系人
      this.$http.get(`/api/contact/GetByCompIdForExhibitor?compId=${this.company.id}`,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data){
                     this.linkList = res.data;
                     console.log(this.linkList,'this.linkList');
                  }
                })
      // status： 0---未审核；1---已审核
      // this.$http
      //   .get(`/api/Contact/GetByCompId?compId=${this.company.id}`, this.header)
      //   .then(res => {
      //     if (res.status === 200 && res.data) {
      //       this.linkList = res.data;
      //     }
      //   });
    },
    getNoLink() {
      // 获取未确认的的联系人
      this.$http.get(`/api/contactDown/GetRecord?joinId=${this.joinInfo.id}`,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data){
                    this.linkList = res.data;
                    console.log(this.linkList,'this.linkList222');
                  }
                })
      // this.$http
      //   .get(
      //     `/api/contactDown/GetRecord?joinId=${this.joinInfo.id}`,
      //     this.header
      //   )
      //   .then(res => {
      //     if (res.status === 200 && res.data) {
      //       let arr = [];
      //       if (res.data.length > 0) {
      //         res.data.map(c => {
      //           if (c.status == 0) {
      //             arr.push(c);
      //           }
      //         });
      //       }
      //       this.linkList = arr;
      //     }
      //   });
    },
    getLinkType() {
      // 获取联系人类别
      this.$http.get(`/api/LinkType/GetList`, this.header).then(res => {
        if (res.status === 200 && res.data) {
          this.linkType = res.data;
          console.log(this.linkType, "this.linkType");
        }
      });
    },
    linkTo() {
      this.selectTab(2);
    }
  }
};
</script>
<style lang="scss" scoped>
.link {
  min-width: 1000px;
  margin: 30px;
  padding-bottom: 50px;
  min-height: 700px;
  background: #fff;
  &-tab {
    padding: 5px 30px 0;
    span {
      display: inline-block;
      height: 100%;
      padding: 8px 16px;
      margin-right: 16px;
      box-sizing: border-box;
      cursor: pointer;
      text-decoration: none;
      position: relative;
      -webkit-transition: color 0.3s ease-in-out;
      transition: color 0.3s ease-in-out;
    }
    &-active {
      color: #d13119;
      border-bottom: 2px solid #d13119;
    }
  }
  &-main {
    padding: 15px;
  }
}

.addPro {
  padding: 40px;
  .icon {
    font-size: 60px;
    text-align: center;
    display: block;
    color: #999;
  }
  span {
    display: block;
    font-size: 18px;
    color: #999;
    text-align: center;
    position: relative;
    top: -5px;
  }
}
.pro {
  margin-bottom: 20px;
  position: relative;
  height: 190px;
  background-color: #fafafa;
  border: solid 1px #f2f2f2;
  &-top {
    width: 100%;
    background: #fff;
    padding: 20px;
    position: relative;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        .name {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          margin-right: 8px;
        }
        .job {
          font-size: 14px;
          color: #4d4d4d;
        }
      }
    }
    p {
      font-size: 14px;
      line-height: 16px;
      padding: 4px 0;
      color: #333;
    }
    .state-Type {
      position: absolute;
      right: 20px;
      bottom: 20px;
    }
  }

  &-tool {
    display: flex;
    height: 48px;
    align-items: center;
    justify-content: space-around;
    background-color: #f7f9fa;
    &-item {
      flex: 1;
      line-height: 48px;
      font-size: 14px;
      color: #808080;
      cursor: pointer;
      text-align: center;
      &:hover {
        color: #1890ff;
      }

      &.z-del {
        &:hover {
          color: #f00;
        }
      }
    }

    &-line {
      background-color: #e8e8e8;
      font-size: 20px;
      width: 1px;
      height: 22px;
      background-color: #e8e8e8;
    }
  }
}

.my-page {
  padding-bottom: 50px;
}
</style>